'use strict';

var PropTypes = require('prop-types');
var React = require('react');
var createReactClass = require('create-react-class');
var LocalizeMixin = require("../../localization/CommonLocalizationMixin");
var ReactDOM = require('react-dom');
var _ = require('lodash');
var FloatLabelField = require('../FloatLabelField.js');
var ResetPasswordForm = require('./ResetPasswordForm.js');
var ADAHelper = require("../../lib/ADAHelpers");
var PageTitle = require('../pageTitle.js').default;
var FacebookLoginApiHelper = require("../../lib/social/FacebookLoginApiHelper");

var LoginPage = createReactClass({
    displayName: 'LoginPage',

    propTypes: {
        initialEmailValue: PropTypes.string, //email to prefill email field with
        loginHandler: PropTypes.func, //handles logging in from email
        handleGoogleSocialClick: PropTypes.func, //handles google social login click
        handleFbSocialClick: PropTypes.func, //handles facebook login click
        handleSignupClick: PropTypes.func, //function to send user somewhere if sign up link clicked
        removeErrorFromProps: PropTypes.func, //if errors passed in from component wrapper then this is the function passed in clear them from wrappers state (takes idx of error)
        forgotPasswordHandler: PropTypes.func, //where/ what to do when user clicks forgot password button
        initialLoginType: PropTypes.string, //facebook, google, email, undef/''/null configures page to only show this type of login.
        userName: PropTypes.string, //should be passed in if using loginType of google, facebook, email as it will display welcome back, username
        messages: PropTypes.array, //show as green alerts
        removeMessageFromProps: PropTypes.func, //takes idx of message so parent can remove it from state
        passwordRequirements: PropTypes.string, //password Requirements for reset password page
        handleResetPassword: PropTypes.func, //resetPasswordFunction
        email: PropTypes.string, //email for reset password header text
        showLoadingSpinner: PropTypes.func, //this function comes from the implementing application's actions
        hideLoadingSpinner: PropTypes.func, //this function comes from the implementing application's actions
        showForgotPasswordHandler: PropTypes.func //is called when the forgot password screen becomes active
    },

    mixins: [LocalizeMixin],

    getInitialState: function getInitialState() {
        var loginType = this.props.initialLoginType || '';
        loginType = loginType.toUpperCase();
        return {
            errors: [],
            messages: [],
            initialEmailValue: (loginType != 'FORGOT_PASSWORD' ? this.props.initialEmailValue : '') || '',
            loginType: loginType || '',
            isFormValid: false
        };
    },

    componentWillMount: function componentWillMount() {
        FacebookLoginApiHelper.loadFbLoginApi();
    },

    componentDidMount: function componentDidMount() {
        document.querySelector('#page-title').focus();
    },

    onSubmit: function onSubmit(e) {
        var self = this;
        e.preventDefault();

        if (this.isValid()) {
            var email = ReactDOM.findDOMNode(this.refs.email).children[0].value;
            var password = ReactDOM.findDOMNode(this.refs.password).children[0].value;
            var credentials = { email: email, password: password };

            //reset form values
            ReactDOM.findDOMNode(this.refs.password).children[0].value = '';
            this.refs.password.isPopulated({ currentTarget: { value: '' } });

            if (this.props.loginHandler) {
                this.props.loginHandler(credentials);
            }
            this.setState({
                errors: []
            });
        } else {
            this.setState({
                errors: [self.getLocalizedText('common_login_name_email_error')]
            });
        }
    },

    handleGoogleSocialClick: function handleGoogleSocialClick() {
        if (this.props.handleGoogleSocialClick) {
            this.props.handleGoogleSocialClick();
        }
    },

    handleFbSocialClick: function handleFbSocialClick() {
        this.props.showLoadingSpinner();
        FacebookLoginApiHelper.loginWithFacebook(this.props.handleFbSocialClick, this.props.hideLoadingSpinner);
    },

    handleSignupClick: function handleSignupClick() {
        if (this.props.handleSignupClick) {
            this.props.handleSignupClick();
        }
    },

    removeError: function removeError(errorId) {
        var errors = _.clone(this.state.errors);

        errors.splice(errorId, 1);

        this.setState({ errors: errors });
    },

    removeErrorFromProps: function removeErrorFromProps(idx) {
        if (this.props.removeErrorFromProps) {
            this.props.removeErrorFromProps(idx);
        }
    },

    validationFunctionEmail: function validationFunctionEmail(inputValue, isInValidationFunction) {
        !isInValidationFunction ? this.isValid() : '';
        var re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}/igm;
        if (!inputValue || inputValue && !inputValue.match(re)) {
            return this.getLocalizedText('common_login_invalid_email');
        } else {
            return '';
        }
    },

    validationFunctionPassword: function validationFunctionPassword(inputValue, isInValidationFunction) {
        !isInValidationFunction ? this.isValid() : '';
        if (!inputValue) {
            return this.getLocalizedText('common_login_required');
        } else {
            return '';
        }
    },

    isValid: function isValid() {
        var errors = '';
        errors += this.validationFunctionEmail(ReactDOM.findDOMNode(this.refs.email).children[0].value, true);
        if (this.refs.password) {
            errors += this.validationFunctionPassword(ReactDOM.findDOMNode(this.refs.password).children[0].value, true);
        }

        this.setState({ isFormValid: !errors });
        return !errors;
    },

    forgotPasswordHandler: function forgotPasswordHandler(e) {
        if (this.props.forgotPasswordHandler && this.isValid()) {
            this.setState({ loginType: '', errors: [] });
            this.props.forgotPasswordHandler({
                login: ReactDOM.findDOMNode(this.refs.email).children[0].value
            }, e);
        }
    },

    clearEmail: function clearEmail() {
        this.setState({ initialEmailValue: '' });
        ReactDOM.findDOMNode(this.refs.email).children[0].value = '';
        this.refs.email.validationFunctionHandler({ currentTarget: { value: '' } });
    },

    resetLoginType: function resetLoginType() {
        this.setState({ loginType: '' });
    },

    hoverImage: function hoverImage(e) {
        if (e.target.src.indexOf('_hover_2.png') > -1) {
            e.target.src = e.target.src.replace('_hover_2.png', '_2.png');
        } else {
            e.target.src = e.target.src.replace('_2.png', '_hover_2.png');
        }
    },

    back: function back() {
        this.setState({ loginType: '' }, function () {
            $('.page-title').first().focus();
        });
    },

    removeMessageFromProps: function removeMessageFromProps(idx) {
        if (this.props.removeMessageFromProps) {
            this.props.removeMessageFromProps(idx);
        }
    },

    showForgotPasswordPage: function showForgotPasswordPage() {
        var _this = this;

        if (this.props.showForgotPasswordHandler) this.props.showForgotPasswordHandler();
        this.setState({ loginType: 'FORGOT_PASSWORD', errors: [] }, function () {
            $('.page-title').first().focus();
            _this.isValid();
        });
    },

    handleResetPassword: function handleResetPassword(formData) {
        if (this.props.handleResetPassword) {
            this.props.handleResetPassword(formData);
        }
    },

    render: function render() {
        var self = this;
        var Config = require('../../lib/config').urls;

        var errors = this.props.errors && this.props.errors.length > 0 ? this.props.errors.map(function (error, idx) {
            return React.createElement(
                'p',
                { key: "prop-err" + idx, className: 'bg-danger alert-danger alert' },
                error,
                React.createElement(
                    'span',
                    { className: 'close', onClick: self.removeErrorFromProps.bind(self, idx), 'aria-hidden': 'true' },
                    '\xD7'
                )
            );
        }) : [''];

        if (this.state.errors.length) {
            this.state.errors.forEach(function (error, idx) {
                errors.push(React.createElement(
                    'p',
                    { key: "prop" + idx, className: 'bg-danger alert-danger alert' },
                    error,
                    React.createElement(
                        'span',
                        { className: 'close', onClick: self.removeError.bind(self, idx), 'aria-hidden': 'true' },
                        '\xD7'
                    )
                ));
            });
        }

        var messages = [''];
        if (this.props.messages && this.props.messages.length) {
            this.props.messages.forEach(function (message, idx) {
                messages.push(React.createElement(
                    'p',
                    { key: "message-prop" + idx, className: 'bg-success alert-success alert' },
                    message,
                    React.createElement(
                        'span',
                        { className: 'close', onClick: self.removeMessageFromProps.bind(self, idx), 'aria-hidden': 'true' },
                        '\xD7'
                    )
                ));
            });
        }

        var loginTypeView = this.state.loginType.toUpperCase() || 'ALL';

        var facebookLoginClass = loginTypeView == 'ALL' || loginTypeView == 'GOOGLE' ? 'col-xs-6 padding-right button-wrapper' : 'col-xs-12 button-wrapper';
        var googleLoginClass = loginTypeView == 'ALL' || loginTypeView == 'FACEBOOK' ? 'col-xs-6 padding-left button-wrapper' : 'col-xs-12 button-wrapper';
        facebookLoginClass += loginTypeView == 'ALL' || loginTypeView == 'FACEBOOK' ? '' : ' hidden';
        googleLoginClass += loginTypeView == 'ALL' || loginTypeView == 'GOOGLE' ? '' : ' hidden';

        var emailLoginMessage = this.props.verification ? this.getLocalizedText('common_login_email_verification_message') : '' + this.getLocalizedText("common_login_welcome_back") + (this.props.userName ? ' ' : '') + this.props.userName + '!';

        var emailPlaceholderText = this.state.initialEmailValue && this.state.loginType && loginTypeView != 'FORGOT_PASSWORD' ? this.getLocalizedText("common_login_email_placeholder") : this.getLocalizedText("common_login_email_address");

        var disableSubmitButton = this.state.isFormValid ? 'btn btn-primary col-xs-12 submit-button' : 'btn btn-primary col-xs-12 submit-button disable-submit';
        var disableSubmit = !this.state.isFormValid;

        var passwordReset = loginTypeView == 'RESET' ? React.createElement(ResetPasswordForm, {
            cntry: this.props.cntry,
            lang: this.props.lang,
            handleResetPassword: this.handleResetPassword,
            email: this.props.email,
            passwordRequirements: this.props.passwordRequirements }) : '';

        var title = '';
        if (loginTypeView == 'RESET') {
            title = React.createElement(PageTitle, { imgAltText: this.getLocalizedText('ada_back'), titleText: this.getLocalizedText('common_login_reset_password') });
        } else if (loginTypeView == "FORGOT_PASSWORD") {
            title = React.createElement(PageTitle, { imgAltText: this.getLocalizedText('ada_back'),
                backHandler: this.back,
                titleText: this.getLocalizedText('common_login_forgot_password') });
        } else {
            title = React.createElement(PageTitle, { imgAltText: this.getLocalizedText('ada_back'), titleText: this.getLocalizedText('common_login_title') });
        }
        return React.createElement(
            'div',
            { className: 'container login-page' },
            React.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4' },
                React.createElement(
                    'div',
                    { className: 'topRow' },
                    title
                ),
                React.createElement(
                    'div',
                    { ref: 'errorAlert', className: 'row', 'aria-live': 'polite' },
                    React.createElement(
                        'div',
                        { className: 'col-xs-12' },
                        errors
                    )
                ),
                React.createElement(
                    'div',
                    { ref: 'errorAlert', className: 'row' },
                    React.createElement(
                        'div',
                        { className: 'col-xs-12', 'aria-live': 'polite' },
                        messages
                    )
                ),
                loginTypeView == 'RESET' ? passwordReset : React.createElement(
                    'div',
                    { className: 'login-box clearfix' },
                    this.state.loginType && loginTypeView != 'FORGOT_PASSWORD' ? React.createElement(
                        'h2',
                        { className: 'welcome-message' },
                        emailLoginMessage
                    ) : '',
                    React.createElement(
                        'form',
                        { onSubmit: loginTypeView == 'ALL' || loginTypeView == 'EMAIL' ? this.onSubmit : function (e) {
                                if (loginTypeView == 'FORGOT_PASSWORD') {
                                    self.forgotPasswordHandler(e);
                                }
                            } },
                        React.createElement(
                            'div',
                            { style: { position: 'relative' } },
                            React.createElement(
                                'div',
                                { onClick: this.clearEmail, className: 'clear-email' },
                                '\xD7'
                            ),
                            React.createElement(FloatLabelField, { initialValue: this.state.initialEmailValue, required: true, type: 'email', id: 'email-input', onChangeHandler: this.validationFunctionEmail,
                                placeHolder: emailPlaceholderText,
                                ref: 'email' })
                        ),
                        loginTypeView == 'ALL' || loginTypeView == 'EMAIL' ? React.createElement(
                            'div',
                            { style: { position: 'relative' } },
                            React.createElement(FloatLabelField, { required: true, type: 'password', id: 'password-input', onChangeHandler: this.validationFunctionPassword,
                                placeHolder: this.getLocalizedText("comp_LoginModal_Password_placeholder"),
                                ref: 'password' })
                        ) : '',
                        React.createElement(
                            'div',
                            { className: loginTypeView == 'ALL' || loginTypeView == 'EMAIL' || loginTypeView == "FORGOT_PASSWORD" ? '' : 'hidden' },
                            React.createElement(
                                'button',
                                { type: 'submit', className: disableSubmitButton, disabled: disableSubmit,
                                    id: 'login-btn' },
                                loginTypeView == "FORGOT_PASSWORD" ? this.getLocalizedText("common_login_submit_button") : this.getLocalizedText("comp_LoginModal_Login_button")
                            )
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: loginTypeView == 'ALL' ? "strike" : "hidden strike" },
                        React.createElement('div', { className: 'strike-bg' }),
                        React.createElement(
                            'span',
                            { className: 'strike-text' },
                            this.getLocalizedText("common_login_with")
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: loginTypeView == 'ALL' || loginTypeView == 'GOOGLE' || loginTypeView == 'FACEBOOK' ? "social-login col-xs-12" : "hidden social-login col-xs-12" },
                        React.createElement(
                            'div',
                            { className: facebookLoginClass },
                            React.createElement(
                                'div',
                                { tabIndex: '0', role: 'button', className: 'social-fb-login', onClick: this.handleFbSocialClick },
                                React.createElement('img', { src: '/images/common/icons/ic_facebook_sign_up.png' }),
                                React.createElement(
                                    'div',
                                    { className: 'center-text' },
                                    React.createElement(
                                        'span',
                                        { className: loginTypeView == 'FACEBOOK' ? '' : 'hidden' },
                                        this.getLocalizedText('common_login_login_with'),
                                        ' '
                                    ),
                                    'Facebook'
                                )
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: googleLoginClass },
                            React.createElement(
                                'div',
                                { tabIndex: '0', role: 'button', className: 'social-google-login', onClick: this.handleGoogleSocialClick },
                                React.createElement('img', { src: '/images/common/icons/ic_google_sign_up.png' }),
                                React.createElement(
                                    'div',
                                    { className: 'center-text' },
                                    loginTypeView == 'GOOGLE' ? this.getLocalizedText('common_login_login_with') + " Google" : 'Google'
                                )
                            )
                        )
                    )
                ),
                React.createElement(
                    'div',
                    { className: loginTypeView === 'FORGOT_PASSWORD' || loginTypeView === 'RESET' ? 'hidden' : '' },
                    React.createElement(
                        'div',
                        { className: 'col-xs-12 forgot-password' },
                        React.createElement(
                            'a',
                            { id: 'forgot-password', role: 'button', onClick: this.showForgotPasswordPage, href: '#' },
                            ' ',
                            this.getLocalizedText('comp_LoginModal_ForgotPassword')
                        )
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'col-xs-12 terms' },
                    React.createElement(
                        'div',
                        { className: loginTypeView == 'FORGOT_PASSWORD' || loginTypeView == 'RESET' ? 'hidden' : '' },
                        React.createElement(
                            'a',
                            { role: 'button', className: this.state.loginType ? '' : 'hidden', onClick: this.resetLoginType, href: '#' },
                            ' ',
                            this.getLocalizedText("common_login_show_all")
                        ),
                        React.createElement(
                            'div',
                            { className: this.state.loginType ? 'hidden' : '' },
                            this.getLocalizedText("common_login_dont_have"),
                            React.createElement(
                                'a',
                                { 'aria-label': this.getLocalizedText("common_login_dont_have") + ' ' + this.getLocalizedText("common_login_sign_up"),
                                    onClick: this.handleSignupClick, href: '#' },
                                ' ',
                                this.getLocalizedText("common_login_sign_up")
                            )
                        ),
                        React.createElement(
                            'div',
                            { id: 'terms-selectable' },
                            this.getLocalizedText("common_login_read_our"),
                            React.createElement(
                                'a',
                                { href: Config.terms[this.props.lang + '_' + this.props.cntry], target: '_blank' },
                                ' ',
                                this.getLocalizedText("common_login_terms_of"),
                                ' '
                            ),
                            ',',
                            React.createElement(
                                'a',
                                { href: Config.privacy[this.props.lang + '_' + this.props.cntry], target: '_blank' },
                                ' ',
                                this.getLocalizedText("common_login_privacy_policy")
                            ),
                            ', ',
                            this.getLocalizedText("common_login_and"),
                            React.createElement(
                                'a',
                                { href: Config.nav.localized[this.props.lang + '_' + this.props.cntry].footerLinks.cookie_policy, target: '_blank' },
                                ' ',
                                this.getLocalizedText("common_login_cookies"),
                                ' '
                            )
                        )
                    )
                )
            )
        );
    }
});

module.exports = LoginPage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loginComponents/loginPage.js
// module id = 594
// module chunks = 0